import React from "react";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        {/* Columna 1 — Logo + descripción */}
        <div className={styles.colBrand}>
          <div className={styles.brandLogo}>
            <img
              src={require("../../assets/Images/logo.png")}
              alt="Vitalclic"
              className={styles.logoImg}
            />
          </div>
          <p className={styles.brandDesc}>
            Plataforma de salud digital que conecta pacientes con los mejores profesionales del
            Perú. Atención presencial y virtual.
          </p>
        </div>

        {/* Columna 2 — Para Pacientes */}
        <div className={styles.col}>
          <h4 className={styles.colTitle}>PARA PACIENTES</h4>
          <ul className={styles.colLinks}>
            <li>
              <Link to="/" className={styles.colLink}>
                Buscar especialista
              </Link>
            </li>
            <li>
              <Link to="/" className={styles.colLink}>
                Teleconsulta
              </Link>
            </li>
            <li>
              <Link to="/" className={styles.colLink}>
                Urgencias
              </Link>
            </li>
            <li>
              <Link to="/mis-consultas" className={styles.colLink}>
                Mi historial
              </Link>
            </li>
          </ul>
        </div>

        {/* Columna 3 — Para Profesionales */}
        <div className={styles.col}>
          <h4 className={styles.colTitle}>PARA PROFESIONALES</h4>
          <ul className={styles.colLinks}>
            <li>
              <Link to="/registrar-profesional" className={styles.colLink}>
                Registrarse
              </Link>
            </li>
            <li>
              <Link to="/panel/consultas/disponibles" className={styles.colLink}>
                Panel de gestión
              </Link>
            </li>
            <li>
              <Link to="/" className={styles.colLink}>
                Soporte
              </Link>
            </li>
          </ul>
        </div>

        {/* Columna 4 — Legal */}
        <div className={styles.col}>
          <h4 className={styles.colTitle}>LEGAL</h4>
          <ul className={styles.colLinks}>
            <li>
              <Link to="/" className={styles.colLink}>
                Términos y condiciones
              </Link>
            </li>
            <li>
              <Link to="/" className={styles.colLink}>
                Privacidad
              </Link>
            </li>
            <li>
              <Link to="/libro-de-quejas" className={styles.colLink}>
                Libro de reclamaciones
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <span>
          © {new Date().getFullYear()} Vitalclic · Tu Mesa en Una. Todos los derechos reservados.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
